import Typography from '@/components/next-ui/Typography';
import { Listbox, Transition } from '@headlessui/react';
import { cx } from 'cva';
import { range } from 'lodash-es';
import { ChevronsUpDownIcon } from 'lucide-react';
import React, { Fragment } from 'react';

const currentYear = new Date().getFullYear();
const yearOptions = range(currentYear, currentYear - 100, -1).map((y) => ({
  id: y,
  label: y,
  value: y,
})); // Provide options for the last 100 years

function YearSelector(props) {
  const { value, onChange, error } = props;
  const hasError = !!error;
  return (
    <div className="relative w-full">
      <Listbox value={value} onChange={onChange} by="value">
        <div className="relative flex flex-col gap-0.5">
          <div className="flex items-center justify-start gap-0.5">
            <Typography variant="h5" className="uppercase" component="label">
              Birth Year
            </Typography>

            <Typography variant="h5" component="span" color="error">
              *
            </Typography>
          </div>

          <Listbox.Button
            className={cx(
              'relative flex w-full cursor-pointer items-center justify-between rounded-lg bg-primary-light-1 px-6 py-3 text-left focus:outline-none',
              hasError && 'border border-error',
            )}>
            <Typography variant="h5" component="span" className="mr-4 truncate">
              {value ? value.label : 'Year'}
            </Typography>
            <ChevronsUpDownIcon
              className="h-5 w-5 text-text-secondary"
              aria-hidden="true"
            />
          </Listbox.Button>
          {hasError && (
            <Typography variant="caption" color="error">
              {error}
            </Typography>
          )}
        </div>

        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <Listbox.Options className="absolute bottom-12 grid max-h-60 w-full grid-cols-1 overflow-auto rounded-md bg-white py-1 text-14 shadow-lg ring-1 ring-black/5 focus:outline-none md:grid-cols-3">
            {yearOptions.map((month) => (
              <Listbox.Option
                key={month.id}
                className={({ active }) =>
                  `relative w-full cursor-pointer select-none px-2 py-2 text-center sm:px-3 ${
                    active
                      ? 'bg-primary-light-1 text-text-primary'
                      : 'bg-white text-text-secondary'
                  }`
                }
                value={month}>
                {({ selected }) => (
                  <span
                    className={`block truncate ${
                      selected ? 'font-medium' : 'font-normal'
                    }`}>
                    {month.label}
                  </span>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </Listbox>
    </div>
  );
}

export default YearSelector;
